export const stoyki_podkatnie = {
    metall_type: [
        {
            actual: true,
            name: "stoyka__sop__600x500",
            pageName: "sop",
            tempName: "sop",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__sop.glb",
            nextMenu: "sop",
            menuTitle: "Стойка для приборов (СОП)",
            title: "Стойка для приборов (СОП)",
            imgName: "stoyka__sop.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stoyka__smo__600x500",
            pageName: "smo",
            tempName: "smo",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__smo.glb",
            nextMenu: "smo",
            menuTitle: "Стойка для оборудования (СМО)",
            title: "Стойка для оборудования (СМО)",
            imgName: "stoyka__smo.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stoyka__som__600x570",
            pageName: "som",
            tempName: "som",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__som.glb",
            nextMenu: "som",
            menuTitle: "Стойка оператора (СОМ)",
            title: "Стойка оператора (СОМ)",
            imgName: "stoyka__som.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 570,
        },
        {
            actual: true,
            name: "stoyka__smp__680x500",
            pageName: "smp",
            tempName: "smp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__smp.glb",
            nextMenu: "smp",
            menuTitle: "Стойка для приборов (СМП)",
            title: "Стойка для приборов (СМП)",
            imgName: "stoyka__smp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 680,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stoyka__spm__600x500",
            pageName: "spm",
            tempName: "spm",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__spm.glb",
            nextMenu: "spm",
            menuTitle: "Стойка (СПМ)",
            title: "Стойка (СПМ)",
            imgName: "stoyka__spm.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stoyka__spl__600x500",
            pageName: "spl",
            tempName: "spl",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__spl.glb",
            nextMenu: "spl",
            menuTitle: "Стойка металлическая (СПЛ)",
            title: "Стойка металлическая (СПЛ)",
            imgName: "stoyka__spl.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stoyka__skk__590x420",
            pageName: "skk",
            tempName: "skk",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__skk.glb",
            nextMenu: "skk",
            menuTitle: "Стойка для коробок (СКК)",
            title: "Стойка для коробок (СКК)",
            imgName: "stoyka__skk.webp",
            allArrTable: "allStoyka",
            defaultWidth: 590,
            defaultDepth: 420,
        },
        {
            actual: true,
            name: "stoyka__sur__1200x600",
            pageName: "sur",
            tempName: "sur",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__sur.glb",
            nextMenu: "sur",
            menuTitle: "Стойка упаковочная для рулонов (СУР)",
            title: "Стойка упаковочная для рулонов (СУР)",
            imgName: "stoyka__sur.webp",
            allArrTable: "allStoyka",
            defaultWidth: 1200,
            defaultDepth: 600,
        },
    ],
    construct_type: [
        {
            actual: true,
            name: "stoyka__sop_kp__600x600",
            pageName: "sop_kp",
            tempName: "sop_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__sop_kp.glb",
            nextMenu: "sop_kp",
            menuTitle: "Стойка для приборов (СОП-КП)",
            title: "Стойка для приборов (СОП-КП)",
            imgName: "stoyka__sop_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 600,
        },
        {
            actual: true,
            name: "stoyka__skp_kp__700x600",
            pageName: "skp_kp",
            tempName: "skp_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__skp_kp.glb",
            nextMenu: "skp_kp",
            menuTitle: "Стойка промышленная для компьютера (СКП-КП)",
            title: "Стойка промышленная для компьютера (СКП-КП)",
            imgName: "stoyka__skp_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 700,
            defaultDepth: 600,
        },
        {
            actual: true,
            name: "stoyka__sr_kp__700x550",
            pageName: "sr_kp",
            tempName: "sr_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__sr_kp.glb",
            nextMenu: "sr_kp",
            menuTitle: "Стойка ремонтная (СР-КП)",
            title: "Стойка ремонтная (СР-КП)",
            imgName: "stoyka__sr_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 700,
            defaultDepth: 550,
        },
        {
            actual: true,
            name: "stoyka__spk_kp__700x550",
            pageName: "spk_kp",
            tempName: "spk_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__spk_kp.glb",
            nextMenu: "spk_kp",
            menuTitle: "Стойка компьютерная (СПК-КП)",
            title: "Стойка компьютерная (СПК-КП)",
            imgName: "stoyka__spk_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 700,
            defaultDepth: 550,
        },
        {
            actual: true,
            name: "stoyka__spl_kp__800x690",
            pageName: "spl_kp",
            tempName: "spl_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__spl_kp.glb",
            nextMenu: "spl_kp",
            menuTitle: "Стойка лабораторная (СПЛ-КП)",
            title: "Стойка лабораторная (СПЛ-КП)",
            imgName: "stoyka__spl_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 800,
            defaultDepth: 690,
        },
        {
            actual: true,
            name: "stoyka__snp_kp__595x500",
            pageName: "snp_kp",
            tempName: "snp_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__snp_kp.glb",
            nextMenu: "snp_kp",
            menuTitle: "Стойка для оборудования (СНП-КП)",
            title: "Стойка для оборудования (СНП-КП)",
            imgName: "stoyka__snp_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 595,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stoyka__smp_kp__700x500",
            pageName: "smp_kp",
            tempName: "smp_kp",
            glbPath: "stoyki_podkatnie/",
            glbName: "stoyka__smp_kp.glb",
            nextMenu: "smp_kp",
            menuTitle: "Стойка (СМП-КП)",
            title: "Стойка (СМП-КП)",
            imgName: "stoyka__smp_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 700,
            defaultDepth: 500,
        },
    ],
};
